var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-common',{attrs:{"nav":_vm.nav}}),_vm._v(" "),_c('div',{staticClass:"center-intro"},[_c('div',{staticClass:"center-intro-content"},[_c('child-detail',{attrs:{"detail":_vm.detail}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2458e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Organization/Children/duty.vue
// module id = null
// module chunks = 